import { NextPage } from 'next'
import { FC, useEffect } from 'react'
import { useSelector } from 'react-redux'

import { selectors } from '../redux'
import Router, { routes } from '../routes/Router'

const AuthGuard = (Page: NextPage<any>): FC<any> => {
  return function AuthGuard(props) {
    const isInit = useSelector(selectors.app.isInit)
    const isConnected = useSelector(selectors.auth.isConnected)

    useEffect(() => {
      if (isInit && !isConnected) {
        Router.pushRoute(routes.home)
      }
    }, [isInit, isConnected])

    if (!isInit || !isConnected) {
      return null
    }

    return <Page {...props} />
  }
}

export default AuthGuard
